import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';
import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/prescriptions'],
  validationMode: 'any',
};

export const prescriptionsSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.PrescriptionsSetup,
  category: PracticeSetupStepCategory.AdditionalSettings,
  title: 'Configure Your Prescriptions',
  description: initRawSchema([
    toParagraphContent(
      `Principle includes a built-in prescription printer, allowing practitioners to generate and print prescriptions directly from within Principle. Before this feature can be used, the medications your practice prescribes need to be configured on the Prescriptions page.`
    ),
    toParagraphContent(
      `Principle has also partnered with Parchment in order to offer e-scripts. Speak to your Customer Success Manager to find out more about activating e-scripts in your workspace (only available in Australia).`
    ),
  ]),
  dependsOn: [],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/prescriptions`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review this page to complete this step',
        };
      })
    );
  },
  pageVisitTracking,
};
